import React, {Fragment, useEffect} from 'react';
import {connect} from "react-redux";
import {setAbortController, setSQFTAr3dPopup} from "../../../../../actions/sqftMenuFunctions";
import ShapesGoogleModelViewer from "./ShapesGoogleModelViewer";
import ShapesThreeJsViewer from "./ShapesThreeJsViewer";
import MultiLoader from "../../../../ui/multiLoader";
import store from "../../../../../store";
import {setMultiLoader} from "../../../../../actions/actionFunctions";
//import GroheFeatures from "../../../look/grohe/groheNavigation/groheFeatures/groheFeatures";
import {setLookActiveCategory, setLookOpened} from "../../../../../actions/lookFunctions";
import {setAPIErrorMessage, setSqftCabinetsGlb} from "../../../../../actions/sqftFunctions";
//import {setCabinetGLBFromCabinetsSet} from "../../../helpers/sqft3dArHelper";
//import sqftShapeManager from "../canvas/store/sqftShapeManager";
//import {SHAPE_PART_ID} from "../../../constants";
//import {isProd} from "../../../../misc/fabricatorHardcode";
import {IS_QKB_UI} from "../../../../../config";
import PropTypes from "prop-types";
import sqftConfig from "../../canvas/store/sqftConfig";

const ThreeDWorkspace = (props) => {
  const {apiErrorMessage, cabinetsGlb, setLookOpened,
    abortRequestController} = props;
  //const {lookActiveFeature, setLookActiveCategory, displayDoorsOnly} = props;

  useEffect(()=> {
    if (!IS_QKB_UI) {
      setLookOpened(false);
    }
  }, [setLookOpened])

  useEffect(()=> {
    return () => {
      if (abortRequestController) {
        abortRequestController.abort();
      }
      store.dispatch(setMultiLoader({activeStep: 8, visible: false, finished: true}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // //todo lookActiveFeature is always triggered
  // //todo CHANGE FEATURES FROM THREE D
  // useEffect(()=> {
  //   // wi will display door styles for this category
  //   //todo
  //   setLookActiveCategory(SHAPE_PART_ID.top_cabinet);
  //
  //   store.dispatch(setMultiLoader({activeStep: 0, visible: false, finished: false}));
  //   store.dispatch(setMultiLoader({activeStep: 0, visible: true, finished: false}));
  //
  //   //todo update lower and bottom separately
  //   //sqftShapeManager.changeShapesFeatureIDIfColorWasChanged(lookActiveFeature);
  //
  //   setCabinetGLBFromCabinetsSet(displayDoorsOnly).then(r => void r);
  //
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [lookActiveFeature])

  return (
    <div className="threeDWorkspace">
      {sqftConfig.threeD.useGoogleModelViewer
        ? <ShapesGoogleModelViewer/>
        : (
          <Fragment>
            {cabinetsGlb && !apiErrorMessage ? <ShapesThreeJsViewer/> : null}
            {apiErrorMessage || <MultiLoader useCabinetLoader={true}/>}
          </Fragment>
        )}
      {/* TODO CHANGE FEATURES FROM THREE D */}
      {/*{ !isProd() ? <GroheFeatures/> : null}*/}
    </div>
  )
};

ThreeDWorkspace.propTypes = {
  displayDoorsOnly: PropTypes.bool
}

const mapStateToProps = (store) => ({
  cabinetsGlb: store.sqftState.cabinetsGlb,
  apiErrorMessage: store.sqftState.apiErrorMessage,
  abortRequestController: store.sqftState.abortRequestController,
  lookActiveFeature: store.lookState.lookActiveFeature,
});

const mapDispatchToProps = {
  setSQFTAr3dPopup,
  setLookActiveCategory,
  setSqftCabinetsGlb,
  setAPIErrorMessage,
  setAbortController,
  setLookOpened,
};


export default connect(mapStateToProps, mapDispatchToProps)(ThreeDWorkspace);
